module.exports = __webpack_public_path__ + "static/media/24_CORTINAO_SEM_BOJO_ESTAMPADO_03.b405870d.jpg";